var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarrantyStatus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 14C0 6.26801 6.26801 0 14 0H25.9934C33.7254 0 39.9934 6.26801 39.9934 14V25.9934C39.9934 33.7254 33.7254 39.9934 25.9934 39.9934H14C6.26801 39.9934 0 33.7254 0 25.9934V14Z",
    fill: "#EFF6FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8028_316)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.6622 20.8299C26.6622 24.9959 23.746 27.0789 20.2799 28.287C20.0984 28.3485 19.9013 28.3456 19.7217 28.2787C16.2472 27.0789 13.3311 24.9959 13.3311 20.8299V14.9975C13.3311 14.7765 13.4188 14.5646 13.5751 14.4084C13.7313 14.2521 13.9433 14.1643 14.1643 14.1643C15.8306 14.1643 17.9136 13.1645 19.3634 11.898C19.5399 11.7472 19.7645 11.6644 19.9966 11.6644C20.2288 11.6644 20.4533 11.7472 20.6299 11.898C22.0879 13.1728 24.1626 14.1643 25.829 14.1643C26.05 14.1643 26.2619 14.2521 26.4182 14.4084C26.5744 14.5646 26.6622 14.7765 26.6622 14.9975V20.8299Z",
    stroke: "#0B5ED7",
    strokeWidth: 1.66639,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8028_316"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.9967,
    height: 19.9967,
    fill: "white",
    transform: "translate(9.99829 9.99835)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarrantyStatus);
export default __webpack_public_path__ + "static/media/warranty_status.d2178df820231ac26149474ffd8c9127.svg";
export { ForwardRef as ReactComponent };